import React from 'react'
import styled from 'styled-components'
import { Tooltip } from 'react-tippy'

import { IconButton } from '../buttons/Buttons'
import { palette } from '../../styles/variables'
import Icon from '../icon/Icon'

const SettingsWrapper = styled.div({
  position: 'relative',
  cursor: 'pointer',
})

const OptionsList = styled.div({
  background: palette.white,
  display: 'flex',
  flexDirection: 'column',
})

const OptionWrapper = styled.div({
  display: 'flex',
  alignContent: 'flex-start',
  justifyContent: 'flex-start',
  padding: '8px 24px 8px 16px',
  cursor: 'pointer',
  '& .icon': {
    display: 'block',
  },
  '& .icon-hover': {
    display: 'none',
  },
  '&:hover': {
    backgroundColor: palette.lightGray20,
    color: palette.orange,
    '& .icon': {
      display: 'none',
    },
    '& .icon-hover': {
      display: 'block',
    },
  },
})

const OptionText = styled.span({
  lineHeight: '35px',
  width: 'fit-content',
  whiteSpace: 'nowrap',
})

class SettingsSelector extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false,
    }

    this.wrapperRef = React.createRef()
  }

  componentDidMount() {
    document.addEventListener('mouseup', this.handleClickOutside)
  }

  componentWillUnmount() {
    document.removeEventListener('mouseup', this.handleClickOutside)
  }

  handleClickOutside = (event) => {
    if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
      this.setState({ isOpen: false })
    }
  }

  openList = () => {
    this.setState((prev) => ({ isOpen: !prev.isOpen }))
  }

  render() {
    const { isOpen } = this.state
    const { style, options, icon } = this.props
    return (
      <SettingsWrapper ref={this.wrapperRef} style={style}>
        <Tooltip
          open={isOpen}
          interactive
          theme="white"
          position="bottom-end"
          offset="-40"
          popperOptions={{
            modifiers: {
              preventOverflow: {
                enabled: false,
              },
              hide: {
                enabled: false,
              },
            },
          }}
          html={
            <OptionsList>
              {options.map((option, index) => (
                <OptionWrapper
                  key={index}
                  onClick={() => {
                    if (option.onClick) option.onClick()
                    this.setState({ isOpen: false })
                  }}
                >
                  {option.icons && (
                    <>
                      <Icon
                        className="icon"
                        src={option.icons[0]}
                        margin="0 15px 0 0"
                      />
                      <Icon
                        className="icon-hover"
                        src={option.icons[1]}
                        margin="0 15px 0 0"
                      />
                    </>
                  )}
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <OptionText>{option.text}</OptionText>
                    {option.description && (
                      <OptionText
                        style={{
                          lineHeight: '14px',
                          fontSize: '12px',
                          whiteSpace: 'pre-wrap',
                          textAlign: 'left',
                        }}
                      >
                        {option.description}
                      </OptionText>
                    )}
                  </div>
                </OptionWrapper>
              ))}
            </OptionsList>
          }
        >
          <IconButton icon={icon} onClick={this.openList} />
        </Tooltip>
      </SettingsWrapper>
    )
  }
}

export default SettingsSelector
